// Generated by Melange

import * as Cn from "../../../../vendored/classnames/Cn.js";
import * as JsxRuntime from "react/jsx-runtime";

function DashboardContentTemplate(Props) {
  let header = Props.header;
  let children = Props.children;
  let classNameOpt = Props.className;
  const className = classNameOpt !== undefined ? classNameOpt : "bg-white";
  return JsxRuntime.jsxs("div", {
    children: [
      header,
      JsxRuntime.jsx("div", {
        children: children,
        className: Cn.fromList({
          hd: "flex-1 overflow-y-auto flex",
          tl: {
            hd: className,
            tl: /* [] */ 0
          }
        })
      })
    ],
    className: Cn.fromList({
      hd: "grow min-h-screen flex flex-col font-hauss",
      tl: /* [] */ 0
    })
  });
}

const make = DashboardContentTemplate;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
